<template>
    <tr v-if="o == n">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td v-if="output ==='input'" width="100%">
                        <ValidationProvider
                            v-slot="{ errors }"
                            :rules="rulesComputed"
                        >
                            <input
                                v-model-phone="res"
                                mode="aggressive"
                                :name="params.key"
                                :class="{'hasError' : doctuPhoneError}"
                                v-tooltip="{
                                    content: doctuPhoneError,
                                    template: $errTemplate,
                                }"
                            >
                        </ValidationProvider>

                    </td>
                    <td v-else width="100%"><textarea rows="2" v-model="res"/></td>
                    <td valign="top" v-html="suffix"></td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': res == o}" style="padding: 0 5px;">
            <a @click="res = o">
                {{ o }}
                <i v-if="(o === '') || (o === null)">✕</i>
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td v-if="output ==='input'" width="100%">
                        <ValidationProvider
                            v-slot="{ errors }"
                            :rules="rulesComputed"
                        >
                            <input
                                v-model-phone="res"
                                mode="aggressive"
                                :name="params.key"
                                :class="{'hasError' : doctuPhoneError}"
                                v-tooltip="{
                                    content: doctuPhoneError,
                                    template: $errTemplate,
                                }"
                            >
                        </ValidationProvider>
                    </td>
                    <td v-else width="100%"><textarea rows="2" v-model="res"/></td>
                    <td valign="top" v-html="suffix"></td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': res == n}" style="padding: 0 5px;">
            <a @click="res = n">
                {{ n }}
                <i v-if="(n === '') || (n === null)">✕</i>
            </a>
        </td>
    </tr>
</template>
<script>
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";
export default {
    mixins:[Base,StrPropsFNO],
    data: function () {
        return {
            doctuPhoneError: null,
            prefix: this.params.prefix ?? '',
            suffix: this.params.suffix ? "&nbsp;" + this.params.suffix : '',
            output: this.params.output ?? 'input',
        }
    },
    created () {
        // this.$refs['line'+this.params.key].validate()
    },
    watch: {
        'res' (val) {
            this.doctuPhoneError = null;

            const phoneRegex = new RegExp(/(\+?\d[- .\(\)]*){11}/im);
            if (!val.trim() || val.match(phoneRegex)) {
                return;
            }

            this.doctuPhoneError = 'Некорректный номер телефона';
        },
    }
}
</script>
